<template>
  <div class="video-description">
    <div>公開日：{{ video.createDate }}</div>
    <div v-html="replaceHTMLSellerInfo(video.desc)"></div>
  </div>
</template>
<script>
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  props: {
    video: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    replaceHTMLSellerInfo
  }
}
</script>
<style scoped>
.video-description {
  background-color: #0000000d;
  border-radius: 8px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/VideoDescription.vue